module.exports = __webpack_public_path__ + "img/upload.3f0eef57.svg";